module.exports = __webpack_public_path__ + "assets/0b5b9bd4b565aca151bf1a4f8341e371.svg";